(function() { window.GUID_a32f140a_45e4_487d_ac1f_80dd12d85fd4 = { getGuid: function() { return "a32f140a-45e4-487d-ac1f-80dd12d85fd4"; } }; })();
var CS;
(function (CS) {
    class CheckBox {
        constructor(inputBox) {
            this.SelectionChange = null;
            let $inputBox = $(inputBox);
            /*Indique que c'est handlé par le nouveau Checkbox.ts dans Controls ou par mud blazor */
            if ($inputBox.hasClass('handled') || $inputBox.hasClass('mud-switch-input')) {
                this.NotImplemented = true;
                return;
            }
            if ($inputBox.data('binded') == true) {
                return;
            }
            else {
                $inputBox.data('binded', true);
            }
            this.CheckPart = $inputBox[0];
            this.CheckBoxId = this.CheckPart.id;
            this.CheckBox = inputBox;
            this.CheckBox.data('context', this);
            if ($(this.CheckPart).hasClass('MultiEditCheckBox')) {
                return;
            }
            $(this.CheckPart).wrap($('<div>'));
            this.DivContainer = $(this.CheckPart).parent();
            this.DivContainer.addClass('CSCheckBoxDiv');
            this.SetEvents();
            if (this.CheckPart.checked == true) {
                this.DivContainer.addClass('CSCheckBoxDivChecked');
            }
            else {
                this.DivContainer.removeClass('CSCheckBoxDivChecked');
            }
            if ($inputBox.hasClass('ThirdState')) {
                this.DivContainer.addClass('ThirdState');
            }
            $inputBox.trigger('loaded', this);
        }
        val(value) {
            if (value != null) {
                $(this.CheckPart).prop('checked', value);
                $(this.CheckPart).trigger('change');
                return this.CheckPart.checked;
            }
            else {
                return this.CheckPart.checked;
            }
        }
        SetStyle() {
        }
        SetEvents() {
            let me = this;
            $(this.DivContainer).off('click');
            $(this.DivContainer).on('click', function (sender) {
                if (me.CheckPart.checked == true) {
                    $(this).removeClass('CSCheckBoxDivChecked');
                    $(me.CheckPart).prop('checked', false);
                }
                else {
                    $(me.CheckPart).prop('checked', true);
                }
                $(me.CheckPart).trigger('change');
            });
            $(this.CheckPart).off('change');
            $(this.CheckPart).on('change', function () {
                if (me.CheckPart.checked == true) {
                    $(me.DivContainer).addClass('CSCheckBoxDivChecked');
                }
                else {
                    $(me.DivContainer).removeClass('CSCheckBoxDivChecked');
                }
                if (me.SelectionChange != null) {
                    me.SelectionChange.call(me);
                }
                me.CheckBox.trigger("CSChange", me);
            });
        }
    }
    CS.CheckBox = CheckBox;
})(CS || (CS = {}));
/*
(function ($) {
    $.fn.CSCheckBox = function () {
        this.each(function () {
            var checkbox = new CS.CheckBox($(this));
            //Donne access au checkbox de n'importe quels scripts.
            eval('document.' + checkbox.CheckBoxId + '=checkbox;');
        });
    };
})(jQuery);


var CS = CS || {};

CS.CheckBox = function (inputBox) {
    var me = this;

    var $inputBox = $(inputBox);
    if ($inputBox.data('binded') == true)
    {
        return;
    }
    else
    {
        $inputBox.data('binded', true);
    }
    
    this.CheckPart = $inputBox[0];
    this.CheckBoxId = this.CheckPart.id;
    this.CheckBox = inputBox;
    this.CheckBox.data('context', this);
    this.SelectionChange = null;
    this.val = function (value) {
        if (value != null) {
            $(this.CheckPart).prop('checked', value);
            $(this.CheckPart).trigger('change');
            return this.CheckPart.checked;
        }
        else {
            return this.CheckPart.checked;
        }
    };
    if ($(this.CheckPart).hasClass('MultiEditCheckBox'))
    {
        return;
    }

    $(this.CheckPart).wrap($('<div>'));
    this.DivContainer = $(this.CheckPart).parent();
    this.DivContainer.addClass('CSCheckBoxDiv');


    this.SetEvents();

    if (this.CheckPart.checked == true) {
        this.DivContainer.addClass('CSCheckBoxDivChecked');
    }
    else {
        this.DivContainer.removeClass('CSCheckBoxDivChecked');
    }

    if ($inputBox.hasClass('ThirdState')) {
        this.DivContainer.addClass('ThirdState');
    }
};

CS.CheckBox.prototype = function () {


    var SetStyle = function () {

    },
    SetEvents = function () {
        var me = this;
        $(this.DivContainer).off('click');
        $(this.DivContainer).on('click', function (sender) {

            if (me.CheckPart.checked == true) {
                $(this).removeClass('CSCheckBoxDivChecked');
                $(me.CheckPart).prop('checked', false);
            }
            else {
                $(me.CheckPart).prop('checked', true);
            }
            $(me.CheckPart).trigger('change');
        });

        $(this.CheckPart).off('change');
        $(this.CheckPart).on('change', function () {
            if (me.CheckPart.checked == true) {
                $(me.DivContainer).addClass('CSCheckBoxDivChecked');
            }
            else {
                $(me.DivContainer).removeClass('CSCheckBoxDivChecked');
            }

            if (me.SelectionChange != null)
                me.SelectionChange.call(me);


            me.CheckBox.trigger("CSChange", me);

        });
    };
    return {
        SetStyle: SetStyle,
        SetEvents: SetEvents
    };

}();
*/ 

//# sourceMappingURL=cs.checkbox.js.map
